import React from "react";
import { AlertCircle } from "lucide-react";

/**
 * Emergency "see a vet" banner. Rendered when vet_visit is true or when
 * emergency_alerts exist. Gentle red palette, not shouty.
 */
export function EscalationBanner({ title, alerts = [], footer, testId }) {
    return (
        <div
            className="rounded-2xl border border-meow-red/25 bg-meow-emergency p-5"
            data-testid={testId || "escalation-banner"}
        >
            <div className="flex items-start gap-3">
                <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-white text-meow-red shadow-[0_2px_10px_rgba(214,69,69,0.15)]">
                    <AlertCircle className="h-4 w-4" strokeWidth={2} aria-hidden />
                </div>
                <div className="flex-1">
                    <h3 className="font-display text-lg font-medium text-meow-charcoal">
                        {title}
                    </h3>
                    {alerts.length > 0 && (
                        <ul className="mt-2 space-y-1.5 text-sm leading-relaxed text-meow-charcoal/90">
                            {alerts.map((a, i) => (
                                <li key={i} className="flex gap-2">
                                    <span className="mt-2 h-1 w-1 shrink-0 rounded-full bg-meow-red" />
                                    <span>{a}</span>
                                </li>
                            ))}
                        </ul>
                    )}
                    {footer && (
                        <p className="mt-3 text-sm font-medium text-meow-red">
                            {footer}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}
